import type { LegalEntityHierarchy } from "@/services/profileService";

/** Depth-first flatten of the legal entity tree (parents before their children). */
export function flattenEntities(entities: LegalEntityHierarchy[]): LegalEntityHierarchy[] {
  return entities.reduce<LegalEntityHierarchy[]>((acc, le) => {
    acc.push(le);
    if (le.subEntities?.length) acc.push(...flattenEntities(le.subEntities));
    return acc;
  }, []);
}

export function findEntityById(
  entities: LegalEntityHierarchy[],
  id: string,
): LegalEntityHierarchy | undefined {
  for (const le of entities) {
    if (le.id === id) return le;
    const found = findEntityById(le.subEntities ?? [], id);
    if (found) return found;
  }
  return undefined;
}
